import { useAtomValue } from "jotai";
import type { CSSProperties, MouseEvent } from "react";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";

interface UseStickerColorButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useStickerColorButton({
    setActiveSubMenu,
}: UseStickerColorButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("stickerColor"));

    const uniqueValues = Array.from(new Set(options.map((option) => String(option.value))));
    const left = uniqueValues[0];
    const right = uniqueValues[1] ?? left;

    const content = (
        <div
            className={styles.color}
            style={
                {
                    "--color-left": left,
                    "--color-right": right,
                } as CSSProperties
            }
        />
    );

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "stickerColor" ? null : { name: "stickerColor", anchor: button },
        );
    };

    return {
        content,
        handleClick,
    };
}
